import groq from 'groq';

import { CLOUDINARY_VIDEO } from './cloudinaryVideo';
import { OVERLINE } from './overline';

export const SKINCARE_HERO = groq`
  skincareHero {
    ${OVERLINE},
    title,
    buttonLabel,
    video {
      ${CLOUDINARY_VIDEO},
      gradientOverlay { desktop, mobile }
    },
    videoMobile {
      ${CLOUDINARY_VIDEO},
      gradientOverlay { desktop, mobile }
    },
    lightboxVideo {
      ${CLOUDINARY_VIDEO},
      "vtt": vtt
    },
    badgeLink { 
      title, 
      href 
    }
  }
`;
